import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
import { setFilterData } from '@Redux/search/actions';

import styles from '../styles.module.scss';
import { useMediaQuery } from 'react-responsive';

import { Slider } from '@lion-design/core';

interface I_BarProps {
    title?: string;
    seqNo: number;
    maxNum: number;
    timeRanges: {
        F_startTime: undefined | number;
        F_endTime: undefined | number;
    };
    tempMFilter?: any;
    setTempMFilter?: Function;
}

const TimeRangeItem = (props: I_BarProps) => {
    const moduleName = 'timeBar';
    const { title, seqNo, maxNum } = props;
    const { tempMFilter, setTempMFilter } = props;

    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const dispatch = useDispatch();
    const { FilterData } = useSelector((state: RootState) => state.search);

    const deviceFilter = isMobile ? tempMFilter : FilterData;
    const setDeviceFilter = (newFilter: any) => {
        if (!isMobile) dispatch(setFilterData(newFilter));
        if (isMobile && setTempMFilter) setTempMFilter(newFilter);
    };

    const [range, setRange] = useState<number[]>([0, 100]);

    // 重設機制
    useEffect(() => {
        if (!deviceFilter) setRange([0, 100]);
    }, [FilterData, tempMFilter]);

    const F_startTime = Number(props.timeRanges.F_startTime);
    const F_endTime = Number(props.timeRanges.F_endTime);
    const hours = F_endTime - F_startTime;

    /** @summary 取得時間字串格式
     * @param value 拉桿位置 (0 ~ 100)
     * @param type 'arrival' | 'departure'
     * @returns 時間字串 (ex. '23:59')
     */
    const getTimeString = (value: number, type: string) => {
        const hhNum = Math.round(hours * (value / 100)) + F_startTime;

        let hhString = hhNum.toString().padStart(2, '0');
        if (hhNum >= 24) hhString = '24';

        let mmString: '00' | '59' = '00';
        if (hhString === '24' || type === 'arrival') mmString = '59';

        return hhString + ':' + mmString;
    };

    // 取得時間字串的 hour 部分
    const getHour = (hm: string): number => {
        if (!hm) return 0; // false

        // 看不懂 XD
        // if (!/^(2[0-4]|[0-1][\d]):[0-5][\d]/.test(hm)) return false;
        // let hour = parseInt(hm.replace(/:[0-5][\d]/gi, ''), 10);

        const hour = Number(hm.split(':')[0]);

        return hour;
    };

    const getTimeRangeUpdatedFilter = (newRange: number[]) => {
        const newFilterData = deviceFilter ? JSON.parse(JSON.stringify(deviceFilter)) : {};

        const newdpTimes = newFilterData.dpTimes
            ? [...newFilterData.dpTimes]
            : new Array(maxNum).fill(null);

        const departureTimeStr = getTimeString(newRange[0], 'departure');
        const arrivalTimeStr = getTimeString(newRange[1], 'arrival');

        // 當所選時間在最早最晚的範圍內 (超出則不須篩選)
        const isValidTimeRange =
            getHour(departureTimeStr) > F_startTime || getHour(arrivalTimeStr) < F_endTime;

        const timeValue = `${departureTimeStr}-${arrivalTimeStr}`;

        newdpTimes[seqNo] = isValidTimeRange ? timeValue : null;

        newFilterData.dpTimes = newdpTimes;

        return newFilterData;
    };

    const timeRangeTitle = `
        ${getTimeString(range[0], 'departure')} ~ 
        ${getTimeString(range[1], 'arrival')}`;

    // 拖拉過程觸發 change
    const handleChange = (value: number[]) => setRange(value);

    // value 改變時 (mouseup/click) 觸發 change
    const handleAfterChange = (value: number[]) => {
        setRange(value);

        const updatedFilter = getTimeRangeUpdatedFilter(value);
        setDeviceFilter(updatedFilter);
    };

    return (
        <div className={styles[moduleName]}>
            <div className={styles.PriceText}>
                {title && <span className={styles.Currency}>{title}</span>}
                <span className={styles.PriceRange}>{timeRangeTitle}</span>
            </div>
            <Slider
                step={hours}
                defaultValue={range}
                onAfterChange={handleAfterChange}
                onChange={handleChange}
                onClick={handleAfterChange}
                // onClick={isMobile ? handleAfterChange : false}
            />
        </div>
    );
};

export default TimeRangeItem;
